const ScheduleIcon = () => {
  return (
    <svg
      width="58"
      height="58"
      viewBox="0 0 58 58"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.8 55.2381C4.205 55.2381 2.83958 54.6972 1.70375 53.6155C0.567917 52.5337 0 51.2333 0 49.7143V11.0476C0 9.52857 0.567917 8.22818 1.70375 7.14643C2.83958 6.06468 4.205 5.52381 5.8 5.52381H8.7V0H14.5V5.52381H37.7V0H43.5V5.52381H46.4C47.995 5.52381 49.3604 6.06468 50.4963 7.14643C51.6321 8.22818 52.2 9.52857 52.2 11.0476V26.7214C51.2817 26.3071 50.3392 25.9619 49.3725 25.6857C48.4058 25.4095 47.415 25.2024 46.4 25.0643V22.0952H5.8V49.7143H24.07C24.4083 50.727 24.8071 51.6937 25.2663 52.6143C25.7254 53.5349 26.2692 54.4095 26.8975 55.2381H5.8ZM43.5 58C39.4883 58 36.0688 56.6536 33.2413 53.9607C30.4138 51.2679 29 48.0111 29 44.1905C29 40.3698 30.4138 37.1131 33.2413 34.4202C36.0688 31.7274 39.4883 30.381 43.5 30.381C47.5117 30.381 50.9313 31.7274 53.7588 34.4202C56.5863 37.1131 58 40.3698 58 44.1905C58 48.0111 56.5863 51.2679 53.7588 53.9607C50.9313 56.6536 47.5117 58 43.5 58ZM48.3575 50.75L50.3875 48.8167L44.95 43.6381V35.9048H42.05V44.7429L48.3575 50.75Z"
        fill="currentColor"
      />
    </svg>
  );
};
export default ScheduleIcon;
